import { getField, updateField } from 'vuex-map-fields';
import axios from '../backend/axios';
import { assignHelper } from './helpers';
import router from '../router';
import SessionApi from '../backend/SessionApi';


export default {
  namespaced: true,
  state: {
    user: {},
    form: {
      email: '',
      password: '',
    },
  },
  mutations: {
    setUser: assignHelper('user'),
    resetFormPassword(state) {
      state.form.password = '';
    },
    updateField,
  },
  actions: {
    async signOut({ commit }) {
      await SessionApi.signOut();
      commit('setUser', {});
      delete localStorage.authorization;
      axios.defaults.headers.Authorization = null;
      if (router.currentRoute.path !== '/') {
        router.push('/');
      }
    },
    async signUp({ state, dispatch }) {
      const response = await SessionApi.signUp(state.form);
      localStorage.authorization = response.headers.authorization;
      axios.defaults.headers.Authorization = response.headers.authorization;
      dispatch('configuration/executePendingAction', null, { root: true });
      return response;
    },
    async signIn({ state, dispatch }) {
      delete localStorage.authorization;
      axios.defaults.headers.Authorization = null;
      const response = await SessionApi
        .signIn({ email: state.form.email, password: state.form.password });
      localStorage.authorization = response.headers.authorization;
      axios.defaults.headers.Authorization = response.headers.authorization;
      dispatch('fetchMe');
      dispatch('configuration/executePendingAction', null, { root: true });
      return response;
    },
    async fetchMe({ commit }) {
      const response = await SessionApi.me();
      commit('setUser', response.data);
    },
    async resetPassword({ commit, state }, { token }) {
      commit('setUser', {});
      delete localStorage.authorization;
      axios.defaults.headers.Authorization = null;
      await SessionApi.resetPassword({ password: state.form.password, token });
      commit('resetFormPassword');
    },
    async sendResetPasswordInstructions(_, { email }) {
      await SessionApi.sendResetPasswordInstructions(email);
    },
  },
  getters: {
    getField,
    connected: (state) => !!state.user.id,
    validated: ({ user }) => user['validated?'],
  },
};
